"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rebass = require("rebass");

var _emotionTheming = require("emotion-theming");

var _space = _interopRequireDefault(require("../../../styles/space"));

var _Card = require("./Card.style");

var _Typography = require("../../Typography");

var _Button = _interopRequireDefault(require("../../Button"));

var _Card2 = _interopRequireDefault(require("./Card"));

var _CardBadge = _interopRequireDefault(require("./CardBadge"));

var _PriceSlash = _interopRequireDefault(require("./PriceSlash/PriceSlash"));

var _AddToCalendar = require("../../AddToCalendar");

var _CardProduct = require("./CardProduct.style");

var CardProduct = function CardProduct(_ref) {
  var banner = _ref.banner,
      bookmark = _ref.bookmark,
      copy = _ref.copy,
      cta = _ref.cta,
      image = _ref.image,
      label = _ref.label,
      link = _ref.link,
      price = _ref.price,
      secondaryCta = _ref.secondaryCta,
      tag = _ref.tag,
      title = _ref.title,
      onClickLabel = _ref.onClickLabel;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      cards = _ref2.cards;

  var hasPrimaryCta = !!cta.url && !!cta.label || !!cta.calendarEvent && !!cta.calendarEvent.startTime;
  var hasSecondaryCta = !!secondaryCta.url && !!secondaryCta.label || !!secondaryCta.calendarEvent && !!secondaryCta.calendarEvent.startTime;
  var hasPrice = !!price && (!!price.current || !!price.previous);
  var hasComponents = hasPrimaryCta || hasSecondaryCta || hasPrice;
  var hasCta = hasPrimaryCta || hasSecondaryCta;
  return /*#__PURE__*/_react.default.createElement(_Card2.default, {
    url: !hasCta ? link === null || link === void 0 ? void 0 : link.url : ''
  }, /*#__PURE__*/_react.default.createElement(_Card.Wrapper, {
    image: image
  }, banner && /*#__PURE__*/_react.default.createElement(_Card.CardBanner, banner), /*#__PURE__*/_react.default.createElement(_Card.CardContainer, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, image && bookmark && /*#__PURE__*/_react.default.createElement(_Card.BookmarkCta, {
    isActive: bookmark.isActive,
    onClick: bookmark.onClick
  }), image && /*#__PURE__*/_react.default.createElement(_Card.Overlay, null, /*#__PURE__*/_react.default.createElement(_Card2.default, {
    url: !hasCta ? link === null || link === void 0 ? void 0 : link.url : ''
  }, /*#__PURE__*/_react.default.createElement(_Card.CardImage, Object.assign({
    preserveStackingContext: true,
    mediaType: "backgroundImage"
  }, image), label && /*#__PURE__*/_react.default.createElement(_CardBadge.default, {
    label: label,
    bookmark: bookmark,
    onClickLabel: onClickLabel
  })))), /*#__PURE__*/_react.default.createElement(_Card.CardContent, {
    image: image
  }, /*#__PURE__*/_react.default.createElement(_rebass.Box, {
    height: "12.8rem"
  }, tag && /*#__PURE__*/_react.default.createElement(_CardProduct.CardProductTag, {
    size: "xsmall"
  }, tag), title && /*#__PURE__*/_react.default.createElement(_Card.CardTitle, {
    size: cards.titleTextSize
  }, title), /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    pt: _space.default.small,
    size: cards.copyTextSize
  }, copy)), hasComponents && /*#__PURE__*/_react.default.createElement(_CardProduct.CtaWrap, {
    hasSecondaryCta: hasSecondaryCta
  }, hasPrimaryCta && /*#__PURE__*/_react.default.createElement(_CardProduct.PrimaryCta, Object.assign({
    variant: cards.primaryCtaProductCard,
    hasSecondaryCta: hasSecondaryCta
  }, cta), cta.label), hasSecondaryCta && /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
    variant: cards.secondaryCtaProductCard
  }, secondaryCta), secondaryCta.label), hasPrice && !hasSecondaryCta && /*#__PURE__*/_react.default.createElement(_PriceSlash.default, {
    price: price,
    cards: cards
  })))))));
};

CardProduct.propTypes = {
  /** Card copy - placed under the title */
  copy: _propTypes.default.string,

  /** Card Primary CTA  */
  cta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    variant: _propTypes.default.oneOf(['primary', 'secondary', 'link']),
    calendarEvent: _propTypes.default.shape(_AddToCalendar.addToCalendarPropTypes)
  }),

  /** Card Secondary CTA  */
  secondaryCta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    variant: _propTypes.default.oneOf(['primary', 'secondary', 'link']),
    calendarEvent: _propTypes.default.shape(_AddToCalendar.addToCalendarPropTypes)
  }),
  image: _propTypes.default.shape({
    src: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  }),

  /** Card image label */
  label: _propTypes.default.string,

  /** Card price -  includes both previous and current price */
  price: _propTypes.default.shape({
    previous: _propTypes.default.string,
    current: _propTypes.default.string
  }),
  title: _propTypes.default.string,
  link: _propTypes.default.shape({
    /** card link URL */
    url: _propTypes.default.string
  }),
  banner: _propTypes.default.shape({
    image: _propTypes.default.shape({}),
    label: _propTypes.default.string
  }),
  bookmark: _propTypes.default.shape({
    isActive: _propTypes.default.bool,
    onClick: _propTypes.default.func
  }),

  /** Card tag, appears above title, mainly used to describe content type */
  tag: _propTypes.default.string,
  onClickLabel: _propTypes.default.func
};
CardProduct.defaultProps = {
  copy: '',
  cta: {
    label: '',
    url: null,
    calendarEvent: null
  },
  secondaryCta: {
    label: '',
    url: null,
    calendarEvent: null
  },
  label: null,
  price: {
    previous: '',
    current: ''
  },
  title: '',
  link: null,
  image: null,
  banner: null,
  bookmark: null,
  tag: '',
  onClickLabel: null
};
var _default = CardProduct;
exports.default = _default;